import { defineAsyncComponent } from 'vue'
import NtLoader from './components/general/NtLoader.vue'
import NtModuleError from './components/general/NtModuleError.vue'

export default {
  install: (app) => {
    // All modules are async
    const modules = import.meta.glob('./modules/**/*.vue')
    for (const path in modules) {
      const name = path.match(/\/([A-Za-z0-9]+)\.vue$/)
      if (!name || name.length < 2) {
        continue
      }
      app.component(
        name[1],
        defineAsyncComponent({
          loader: modules[path],
          loadingComponent: NtLoader,
          errorComponent: NtModuleError,
        }),
      )
    }
  },
}
